import { useI18n } from "@/i18n";
import { Mail, ShieldCheck, Wrench, User } from "lucide-react";

const Enterprise = () => {
  const { language } = useI18n();

  const roles = language === 'en' ? [
    {
      icon: ShieldCheck,
      role: 'Admin',
      desc: 'Full platform control',
      items: [
        'Manage users by department & team',
        'Review and approve bot publishing',
        'Configure access policies',
      ],
    },
    {
      icon: Wrench,
      role: 'Creator',
      desc: 'Build and publish AI bots',
      items: [
        'Create bots with isolated knowledge bases',
        'Control which users or groups can see each bot',
        'Publish to the organization bot store',
      ],
    },
    {
      icon: User,
      role: 'User',
      desc: 'Use approved bots privately',
      items: [
        'Access bots approved by admins',
        'All interactions stay on-device',
        'Data never leaves your Mac',
      ],
    },
  ] : [
    {
      icon: ShieldCheck,
      role: 'Admin',
      desc: '平台全局管控',
      items: [
        '按部门与团队管理用户',
        '审批 Bot 发布',
        '配置访问策略',
      ],
    },
    {
      icon: Wrench,
      role: 'Creator',
      desc: '搭建并发布 AI Bot',
      items: [
        '创建带独立知识库的 Bot',
        '控制哪些用户或群组可见每个 Bot',
        '发布到组织内 Bot 商店',
      ],
    },
    {
      icon: User,
      role: 'User',
      desc: '私密使用已审批的 Bot',
      items: [
        '访问管理员审批的 Bot',
        '所有交互留在设备端',
        '数据绝不离开你的 Mac',
      ],
    },
  ];

  return (
    <section className="py-24 md:py-32 bg-[#1F2937]">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
              {language === 'en' ? 'AI Governance for Enterprise' : '企业级 AI 治理'}
            </h2>
            <p className="text-lg text-gray-400 max-w-2xl mx-auto">
              {language === 'en'
                ? 'Three roles, clear boundaries. Every action scoped, every byte on-device.'
                : '三种角色，清晰边界。每个操作受控，每个字节留在设备上。'}
            </p>
          </div>

          {/* Role-based governance */}
          <div className="grid md:grid-cols-3 gap-8 mb-14">
            {roles.map((role, i) => (
              <div key={i} className="bg-white/5 rounded-2xl p-8">
                <div className="mb-5 inline-flex p-3 rounded-xl bg-[#1E88C8]/15">
                  <role.icon className="w-6 h-6 text-[#1E88C8]" />
                </div>
                <h3 className="text-xl font-bold text-white">{role.role}</h3>
                <p className="text-sm text-gray-400 mt-1 mb-5">{role.desc}</p>
                <ul className="space-y-3">
                  {role.items.map((item, j) => (
                    <li key={j} className="flex items-start gap-2 text-sm text-gray-400 leading-relaxed">
                      <span className="text-[#1E88C8] mt-0.5">•</span>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Enterprise CTA */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-10 text-center">
            <h3 className="text-lg font-semibold text-white mb-2">
              {language === 'en' ? 'Ready to deploy for your team?' : '准备为团队部署？'}
            </h3>
            <p className="text-sm text-gray-400 mb-5">
              {language === 'en'
                ? 'Talk to us about enterprise pricing, custom deployment, and dedicated support.'
                : '联系我们了解企业定价、定制部署与专属支持。'}
            </p>
            <div className="inline-flex items-center gap-2 text-white bg-white/10 rounded-lg px-5 py-2.5">
              <Mail className="h-4 w-4 text-gray-400" />
              <span className="text-sm font-medium select-all">eric.lam@estha.ai</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Enterprise;
